import apiClient from "./api"; // On utilise le client API configuré

export const generateSecurityReport = async (AccountId, SecurityId, domainId) => {
  try {
    const response = await apiClient.post(
      `api/Security/generate-report/${AccountId}/${SecurityId}/${domainId}`,
      null,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 404) {
        throw new Error(error.response.data?.message || "Aucun titre trouvé pour ce compte.");
      }
      throw new Error(error.response.data?.message || "Une erreur est survenue lors de la génération du rapport.");
    }
    throw new Error("Impossible de contacter le serveur.");
  }
};

// Générer un rapport pour toutes les sécurités d'un utilisateur
// src/services/securityService.js

export const generateAllSecurityReport = async (accountId, domainId, period = null) => {
  try {
    // Construire l'URL avec le paramètre optionnel
    let url = `api/Security/generate-All-report/${accountId}/${domainId}`;
    
    if (period !== null && period !== undefined) {
      url += `?periode=${period}`;
    }
    
    const response = await apiClient.post(url);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 
                    "Erreur inconnue lors de la génération du rapport.";
    throw new Error(message);
  }
};

